import { useState } from 'react';

import { XStack, YStack } from '@/components/ui/layout/layout';

import { McpInfoCallTable } from './components/mcp-info-call-table';
import { McpInfoDetailPanel } from './components/mcp-info-detail-panel';
import { McpInfoSummaryTiles } from './components/mcp-info-summary-tiles';
import { McpInfoToolbar } from './components/mcp-info-toolbar';
import { useMcpCallsQuery, useMcpUsageSummaryQuery } from './mcp-info.query';

import type { McpCallFilters } from './mcp-info.types';

const DEFAULT_FILTERS: McpCallFilters = {
  clientName: null,
  toolName: null,
  sinceHours: 24,
};

export function McpInfo() {
  const [filters, setFilters] = useState<McpCallFilters>(DEFAULT_FILTERS);
  const [selectedCallId, setSelectedCallId] = useState<string | null>(null);

  const { data: calls, isLoading } = useMcpCallsQuery(filters);
  const { data: summary } = useMcpUsageSummaryQuery(filters.sinceHours);

  return (
    <YStack className="h-full overflow-hidden">
      <McpInfoToolbar
        filters={filters}
        summary={summary}
        callCount={calls?.calls.length ?? 0}
        onChange={(update) => setFilters((prev) => ({ ...prev, ...update }))}
      />
      <McpInfoSummaryTiles summary={summary} />
      <XStack className="flex-1 min-h-0">
        <div className="flex-1 min-w-0 overflow-hidden">
          <McpInfoCallTable
            calls={calls?.calls ?? []}
            isLoading={isLoading}
            selectedCallId={selectedCallId}
            onSelect={setSelectedCallId}
          />
        </div>
        {selectedCallId && (
          <div className="w-[420px] border-l border-border overflow-y-auto shrink-0">
            <McpInfoDetailPanel
              callId={selectedCallId}
              onClose={() => setSelectedCallId(null)}
            />
          </div>
        )}
      </XStack>
    </YStack>
  );
}
